import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import useTrans from '../../hooks/useTrans';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getListProjectWeb } from '../../redux/actions/project';
import _ from 'lodash';

import MetaSeo from '../MetaSeo';
export default function Project(props) {
    useEffect(() => {
        // if (props.match.params.id) {
        //     getDetail(props.match.params.id);
        // }
        setRows(props.rows);
        setTotal(props.total);
        setPage(props.page);
        setDataField(props.data_field.data);
        setDataLanguage(props.data_language.data);

    }, [props]);
    const [rows, setRows] = useState(props.rows || []);
    const [total, setTotal] = useState(props.total || null);
    const [page, setPage] = useState(props.page || 1);
    const [limit, setLimit] = useState(props.limit || 10);
    const [search, setSearch] = useState(null);
    const [is_search, setIsSearch] = useState(false);
    const dispatch = useDispatch();
    const trans = useTrans();
    const [data_field, setDataField] = useState(props.data_field.data || []);
    const [data_language, setDataLanguage] = useState(props.data_language.data || []);
    const [array_tag_id, setArrayTagId] = useState([]);
    const filterTag = async (tag_id) => {
        if (array_tag_id.length && array_tag_id.includes(tag_id)) {
            let tag_array = array_tag_id.filter(it => it !== tag_id);
            setArrayTagId(tag_array);
            const data = await getListProjectWeb({ tag_id: tag_array, name: search?.trim() }, dispatch);
            if (data) {
                setRows(data.rows);
                setTotal(data.total);
                setPage(data.page);
            }

        } else {
            let tag_array = [...array_tag_id];
            tag_array.push(tag_id);
            setArrayTagId(tag_array);
            const data = await getListProjectWeb({ tag_id: tag_array, name: search?.trim() }, dispatch);
            if (data) {
                setRows(data.rows);
                setTotal(data.total);
                setPage(data.page);
            }
        }
    };
    const filterOneTag = async (tag_id) => {
        let tag_array = [];
        tag_array.push(tag_id);
        const data = await getListProjectWeb({ tag_id: tag_array, name: search }, dispatch);
        if (data) {
            setRows(data.rows);
            setTotal(data.total);
            setPage(data.page);
        }
    };
    const loadMore = async () => {
        let new_page = parseInt(page) + 1;
        setPage(new_page);
        const data = await getListProjectWeb({ page: new_page, limit, tag_id: array_tag_id }, dispatch);
        if (data) {
            const new_data = [...rows, ...data.rows];
            setRows(new_data);
        }
    };
    const onSearch = async () => {
        let data = await getListProjectWeb({ page: 1, limit, name: search.trim(), tag_id: array_tag_id }, dispatch);
        setIsSearch(true);
        if (data) {
            setRows(data.rows);
            setTotal(data.total);
        }
    };
    const onSearchDelay = _.debounce(() => onSearch(), 100);
    const onEnterkey = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };
    const dataSeo = {
        url: process.env.NEXT_PUBLIC_SEO_URL,
        type: 'website',
        title: "案件| TCOM JAPAN",
        description: 'TCOM JAPANは、日本のお客様を満足させるために、ほぼすべての分野で多くの大型プロジェクトを実施してきました。',
        domain: process.env.NEXT_PUBLIC_DOMAIN,
        // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
        card: 'summary_large_image',
    };
    return (
        <>
            <MetaSeo {...dataSeo} />
            <div className='main-content'>
                <div className='r-big-banner'>
                    <div className='r-page-title'>
                        <div className='container'>
                            <h3>{trans.project.feature_project}</h3>
                            <p>{trans.project.feature_project_description}</p>
                        </div>
                    </div>
                </div>
                <div className='r-top'>
                    <div className='container'>
                        <div className='row'>
                            {/* <div className='col-12'> */}
                            {/* <div className='search'>
                                <form>
                                    <input type='text' placeholder={trans.project.search} />
                                    <button type='submit'>
                                        <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <path d='M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z' stroke='#A7A7A7' strokeWidth={2} strokeLinecap='round' />
                                        </svg>
                                    </button>
                                </form>
                            </div> */}
                            <div className='col-12 '>
                                <div className='search'>
                                    <input onChange={(e) => setSearch(e.target.value)} value={search} type='text' placeholder={trans.project.search} onKeyDown={onEnterkey} />
                                    <button type='submit' onClick={onSearchDelay}>
                                        <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <path d='M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z' stroke='#A7A7A7' strokeWidth={2} strokeLinecap='round' />
                                        </svg>
                                    </button>

                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className='r-tag'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 col-md-6'>
                            <h3>{trans.project.field}</h3>
                            <ul>
                                {data_field.map(item => {
                                    return (
                                        <li onClick={() => filterTag(item.id)} key={item.id + '_' + array_tag_id.includes(item.id)} className={array_tag_id.includes(item.id) ? 'active' : ''}><a>{item.name}</a></li>
                                    );
                                })}

                            </ul>
                        </div>
                        <div className='col-12 col-md-6'>
                            <h3>{trans.project.language}</h3>
                            <ul>
                                {data_language.map(item => {
                                    return (
                                        <li onClick={() => filterTag(item.id)} key={item.id + '_' + array_tag_id.includes(item.id)} className={array_tag_id.includes(item.id) ? 'active' : ''}><a>{item.name}</a></li>
                                    );
                                })}

                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}
                {rows.length ? <div className='r-project-list'>
                    <div className='container'>
                        <div className='row'>
                            {rows.map(item => {
                                return (
                                    <div className='col-12 col-md-6'>
                                        <a href={`/project/${item.seo_url}`} className='image'>
                                            <img src={item.background_image} alt='' />
                                        </a>
                                        <div className='content'>
                                            <a href={`/project/${item.seo_url}`} className='title'>{item.name}</a>
                                            <ul className='tag'>
                                                {item.project_hook_tag.map(it => {
                                                    return (
                                                        <li>
                                                            <a // onClick={() => filterOneTag(it?.project_tag?.id)}
                                                            >{it?.project_tag?.name}</a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            <p className='desc' title={item.description}>
                                                {item.description}
                                            </p>
                                            <a href={`/project/${item.seo_url}`} className='readmore'>
                                                {trans.text_button.read_more}
                                                <svg width={20} height={20} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                    <path fillRule='evenodd' clipRule='evenodd' d='M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z' fill='#0063AA' />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                            {rows.length < total ? (
                                <div className='col-12 text-center'>
                                    <a onClick={() => loadMore()} className='see-more'>
                                        {trans.project.load_more}
                                        <svg width={78} height={39} viewBox='0 0 78 39' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                            <path fillRule='evenodd' clipRule='evenodd' d='M77.1601 20.821C77.5415 20.4396 77.7557 19.9224 77.7557 19.3831C77.7557 18.8438 77.5415 18.3266 77.1601 17.9453L59.9062 0.691336C59.5248 0.310001 59.0076 0.0957691 58.4684 0.0957692C57.9291 0.0957693 57.4119 0.31 57.0305 0.691336C56.6492 1.07267 56.435 1.58988 56.435 2.12917C56.435 2.66846 56.6492 3.18566 57.0305 3.567L70.8136 17.35L2.28132 17.3472C2.01395 17.3472 1.7492 17.3998 1.50218 17.5021C1.25517 17.6045 1.03072 17.7544 0.841666 17.9435C0.652608 18.1325 0.50264 18.357 0.400324 18.604C0.298006 18.851 0.245348 19.1158 0.245346 19.3831C0.245347 19.6505 0.298007 19.9153 0.400323 20.1623C0.502642 20.4093 0.652613 20.6337 0.84167 20.8228C1.03073 21.0118 1.25517 21.1618 1.50218 21.2641C1.7492 21.3664 2.01395 21.4191 2.28131 21.4191L70.8136 21.4162L57.0305 35.1993C56.6492 35.5806 56.4349 36.0978 56.4349 36.6371C56.4349 37.1764 56.6492 37.6936 57.0305 38.0749C57.4119 38.4563 57.9291 38.6705 58.4684 38.6705C59.0076 38.6705 59.5248 38.4563 59.9062 38.0749L77.1601 20.821Z' fill='#FDFDFD' />
                                        </svg>
                                    </a>
                                </div>

                            ) : ''}
                        </div>
                    </div>
                </div> : <div id='not-found'>
                    <div className='main-content'>
                        <div className='container'>
                            <div className='inner'>
                                <div className='image'>
                                    <img src='/assets/images/404-search.png' alt='' />
                                </div>
                                <h3>{trans.project.no_result}</h3>
                                <a href='/' className='btn-back'>{trans.project.back_home}</a>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div >
        </>
    );
}
